// Description: This component displays a row of event information, including the event image, title, dates, composers, and venue. It also includes a "More" button for additional details.
import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
// import { LanguageSwitcher } from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleAppointmentsClick = (e) => {
    e.preventDefault();
    closeMenu();
    if (location.pathname === "/" || location.pathname === "/home") {
      const element = document.getElementById("upcoming-performance");
      if (element) {
        const offset = 80;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    } else {
      navigate("/#upcoming-performance");
      setTimeout(() => {
        const element = document.getElementById("upcoming-performance");
        if (element) {
          const offset = 80;
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - offset,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    closeMenu();

    // Always clear any hash and force scroll to top
    if (location.pathname === "/" || location.pathname === "/home") {
      // If already on home page, just clear hash and scroll to top
      window.history.pushState("", document.title, location.pathname);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // If on another page, navigate to home without hash
      navigate("/");
      // Scroll to top after a short delay to ensure navigation completes
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <header className="fixed top-0 w-full bg-black text-[#DFDFDF] z-[1000] flex flex-col items-center">
      <div className="w-full flex items-center p-4">
        <button
          className="md:hidden text-[#DFDFDF] hover:text-white focus:outline-none mr-4"
          onClick={toggleMenu}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={
                isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
              }
            ></path>
          </svg>
        </button>
        <div className="mt-2 flex-1 mr-10 md:ml-0 text-center hover:scale-[1.01] transition-transform duration-200">
          <a
            href="/"
            className="text-3xl no-underline text-white text-outline-shadow-light"
            onClick={handleLogoClick}
          >
            <span className="font-cinzel-decorative-important text-[36px]">
              O
            </span>
            <span className="font-cinzel-important text-[30px]">PERA</span>
            <span className="font-cinzel-important text-[36px]">T</span>
            <span className="font-cinzel-important text-[30px]">ODAY</span>
            <span className="font-corinthia-important text-[30px]">.org</span>
          </a>
        </div>
      </div>
      <hr
        className={`w-full border-t border-[#DFDFDF] my-0 ${
          isMenuOpen ? "block" : "hidden md:block"
        }`}
      />
      <div className="w-full max-w-[1260px] flex justify-center sm:mt-2">
        <nav
          className={`w-full flex-col ${
            isMenuOpen ? "flex" : "hidden"
          } md:flex md:flex-row md:gap-8 p-4 md:p-0 md:py-2 ${
            isMenuOpen ? "text-lg" : "text-sm"
          } md:text-sm md:justify-center`}
        >
          <NavLink
            to="/opera-houses-and-festivals"
            className={({ isActive }) =>
              `text-[#DFDFDF] no-underline hover:text-white uppercase font-normal md:text-center py-2 md:py-0 ${
                isActive ? "text-white" : ""
              }`
            }
            onClick={closeMenu}
          >
            {t("header.destinations")}
          </NavLink>
          <NavLink
            to="/performers"
            className={({ isActive }) =>
              `text-[#DFDFDF] no-underline hover:text-white uppercase font-normal md:text-center py-2 md:py-0 ${
                isActive ? "text-white" : ""
              }`
            }
            onClick={closeMenu}
          >
            Performers
          </NavLink>
          <NavLink
            to="/composers"
            className={({ isActive }) =>
              `text-[#DFDFDF] no-underline hover:text-white uppercase font-normal md:text-center py-2 md:py-0 ${
                isActive ? "text-white" : ""
              }`
            }
            onClick={closeMenu}
          >
            {t("header.composers")}
          </NavLink>
          <NavLink
            to="/newsletter"
            className={({ isActive }) =>
              `text-[#DFDFDF] no-underline hover:text-white uppercase font-normal md:text-center py-2 md:py-0 ${
                isActive ? "text-white" : ""
              }`
            }
            onClick={closeMenu}
          >
            {t("header.newsletter")}
          </NavLink>
          <a
            href="/#upcoming-performance"
            className="hidden text-[#DFDFDF] no-underline hover:text-white uppercase font-normal md:text-center py-2 md:py-0 items-center group"
            onClick={handleAppointmentsClick}
          >
            {/* <span className="md:hidden">SEARCH</span>
            <img
              src="/images/glass.png"
              alt="Search"
              className="hidden md:block w-7 h-7 ml-1 object-contain transition-transform duration-200 group-hover:scale-110"
              style={{ filter: "brightness(1)", transition: "filter 0.2s" }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.filter = "brightness(5)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.filter = "brightness(1)")
              }
            /> */}
            <p>{t("header.upcomingPerformances")}</p>
          </a>
          {/* <LanguageSwitcher /> */}
        </nav>
      </div>
    </header>
  );
}

export default Header;
